import React, { useState, useEffect } from "react"
import styled from "styled-components"
import media from "styled-media-query"
import Menu from "@material-ui/icons/Menu"
import Close from "@material-ui/icons/Close"
import { Collapse } from "react-collapse"
import NextImg from "@/common/components/NextImg/index"

import Logo from "@/common/assets/image/lucky-bag-2023/KGX91APP.webp"

import NavItem from "./NavItem"
import NavItemIconRow from "./NavItemIconRow"

import "react-toastify/dist/ReactToastify.css"

import { theme } from "./mixin"
import Button from "./Button"

export default function TopNav({
  address,
  isNavOpen,
  setNavOpen,
  onDisconnect,
  setWalletConnectModal,
  dayS,
  dayE
}) {
  const [isShow, setIsShow] = useState("top")

  const closeMenu = () => {
    setNavOpen(false)
  }
  const hideMenu = () => {
    setIsShow("close")
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  let lastScrollTop = 0
  const handleScroll = () => {
    let clientHeight = document.documentElement.clientHeight
    let scrollTop = document.documentElement.scrollTop
    let scrollHeight = document.documentElement.scrollHeight

    if (scrollTop < lastScrollTop) {
      setIsShow("show")
    } else {
      setIsShow("close")
    }
    lastScrollTop = document.documentElement.scrollTop
    if (scrollTop + clientHeight === scrollHeight) {
    }
    if (scrollTop === 0) {
      setIsShow("top")
    }
  }

  const rendererButton = ({ total, days, hours, minutes, seconds }) => {
    return (
      <>
        {total === 0 ? (
          <Button
            content="立刻領取"
            href="#top"
            id="toybox-topMenuButton"
            onClick={closeMenu}
          />
        ) : (
          <Button
            className="hover"
            content="活動即將開始"
            id="toybox-HeroButton"
            secondary
            disable
            onClick={closeMenu}
          />
        )}
      </>
    )
  }

  return (
    <>
      <Wrapper className={isShow}>
        <NavLogosWrapper>
          <NextImg src={Logo} />
        </NavLogosWrapper>
        {/* 1024px以上裝置 */}
        <DesktopNav>
          <NavItem text="如何參與" to="#INFO" />
          <NavItem text="精選好禮" to="#REWARDS" />
          <NavItem text="萬元大獎" to="#BONUS" />
          <NavItem text="參與品牌" to="#PARTNERS" />
          <NavItem
            text="FAQ"
            to="https://kryptogo.notion.site/KryptoGO-x-91APP-NFT-3ce05f20b3a34a6487c76a5713e8bde3"
            blank
            id="toybox-topMenuFAQ"
          />
          {/* <ButtonWrapper>
            <Countdown date={dayS} renderer={rendererButton} />
          </ButtonWrapper> */}
        </DesktopNav>
        {/* 1024px以下裝置 */}
        <MenuIconWrapper onClick={() => setNavOpen(true)}>
          <Menu
            style={{
              fontSize: "24px",
              color: theme.secondary
            }}
          />
        </MenuIconWrapper>
      </Wrapper>
      {/* 1024px以下裝置 */}
      <Collapse isOpened={isNavOpen}>
        <CollapseNav className={isNavOpen === true ? "show" : "close"}>
          <XWrapper onClick={closeMenu}>
            <Close
              style={{
                fontSize: "24px",
                color: theme.secondary
              }}
              onClick={closeMenu}
            />
          </XWrapper>

          <NavItemIconRow text="回到頂部" to="#top" onClick={closeMenu} />
          <NavItemIconRow text="如何參與" to="#INFO" onClick={closeMenu} />
          <NavItemIconRow text="精選好禮" to="#REWARDS" onClick={closeMenu} />
          <NavItemIconRow text="萬元大獎" to="#BONUS" onClick={closeMenu} />
          <NavItemIconRow text="參與品牌" to="#PARTNERS" onClick={closeMenu} />
          <NavItemIconRow
            text="FAQ"
            to="https://kryptogo.notion.site/KryptoGO-x-91APP-NFT-3ce05f20b3a34a6487c76a5713e8bde3"
            onClick={closeMenu}
            blank
          />
        </CollapseNav>
      </Collapse>
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  width: 100%;
  padding: 0 60px;
  transition: all 0.6s;
  @media (${theme.md}) {
    padding: 0 20px 0px 20px;
  }
  &.show {
    transform: translate(0, 0);
    background-color: #ffffffcf;
    /* backdrop-filter: blur(5px); */
  }
  &.close {
    transform: translate(0, -65px);
  }
`
const DesktopNav = styled.div`
  ${media.lessThan("1100px")`
    display: none;
  `}
`
const CollapseNav = styled.div`
  background: ${theme.StrongBgLinearBottom};
  background: linear-gradient(to Top, #ffe18013, #558d8a76);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  backdrop-filter: blur(15px);
  padding: 100px 60px 60px 60px;
  transition: all 0.8s;
  ${media.greaterThan("1111px")`
  display: none;
  `}
  &.show {
    transform: translate(0, 0);
    opacity: 1;
  }
  &.close {
    transform: translate(0, -100vh);
    opacity: 0;
  }
  @media (${theme.md}) {
    padding: 100px 24px 24px 24px;
  }
`
const MenuIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #fff;
  /* height: 100px; */

  cursor: pointer;

  ${media.greaterThan("1024px")`
    display: none;
  `}
`
const NavLogosWrapper = styled.div`
  width: 300px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  @media (${theme.md}) {
    width: 250px;
  }
`

const ButtonWrapper = styled.div`
  display: inline;
  padding: 0 0 0 24px;
`
const XWrapper = styled.div`
  position: absolute;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  top: 20px;
  right: 60px;
  background-color: #fff;
  z-index: 999999;
  cursor: pointer;
  @media (${theme.md}) {
    right: 20px;
    top: 20px;
  }
`
